import { ITransaction } from '@/entities/transaction';

import { VabsPaymentDirection, VabsPaymentSystem } from '@/shared/api';
import { ArrowUpIcon, Plus2, ExchangeIcon } from '@/shared/assets';
import { formatAmountValue, getValueWithCurrency } from '@/shared/lib';
import { shortText } from '@/shared/lib/utils/text';
import { Avatar, Heading, Typography } from '@/shared/ui';

import { FINAL_STATUSES } from '../../config';

export const TransactionDetailHead = ({
  tx,
  onClose,
}: {
  tx: ITransaction;
  onClose: () => void;
}) => {
  const isExchange = tx.paymentSystem === VabsPaymentSystem.Exchange;
  const isTopUp = tx.type === VabsPaymentDirection.Incoming && tx.paymentSystem !== VabsPaymentSystem.Exchange;
  const isSend = tx.type === VabsPaymentDirection.Outgoing;
  const amount = isExchange
    ? getValueWithCurrency(`+${formatAmountValue(tx.targetAmount)}`, tx.targetCurrency)
    : getValueWithCurrency(
      formatAmountValue(isTopUp ? tx.sourceAmount : tx.sourceTotalAmount),
      tx.sourceCurrency,
    );

  return (
    <div className="mb-10 mt-14 flex flex-col items-center">
      <Avatar className="mb-5 flex size-20 items-center justify-center bg-white">
        {isExchange && <ExchangeIcon className="min-h-12 min-w-12 [&_path]:fill-icon-contrast-500" />}
        {isTopUp && (
          <Plus2 className="min-h-12 min-w-12 [&_path]:fill-icon-contrast-500" />
        )}
        {isSend && <ArrowUpIcon className="text-icon-contrast-500" />}
      </Avatar>

      <Heading className="mb-4" tag="span" variant="l">
        {isSend && "- "}
        {getValueWithCurrency(
          formatAmountValue(isTopUp ? tx.sourceAmount : tx.sourceTotalAmount),
          tx.sourceCurrency,
        )}
      </Heading>

      {isExchange && (
        <div className="flex flex-col items-center">
          <Typography variant="16-m-caps">exchange:</Typography>
          <Typography variant="16-m-caps">{`${tx.sourceCurrency} → ${tx.targetCurrency}`}</Typography>
        </div>
      )}

      {isTopUp && (
        <div className="flex flex-col items-center">
          <Typography variant="16-m-caps">added to your:</Typography>
          <Typography variant="16-m-caps">{`${tx.sourceCurrency} account`}</Typography>
        </div>
      )}

      {isSend && (
        <div className="flex flex-col items-center">
          <Typography variant="16-m-caps">
            {!FINAL_STATUSES.includes(tx.status) ? 'sending to:' : 'sent to:'}
          </Typography>
          <Typography variant="16-m-caps">
            {shortText(tx.accountHolder || tx.name, 24)}
          </Typography>
        </div>
      )}
    </div>
  );
};
